import React, { useState } from 'react';
import { Controller } from 'react-hook-form';
import { Chip, Typography } from '@navi/web-ui/lib/primitives';
import ErrorIconOutline from '@cp/src/assets/icons/ErrorIconOutline';
import cx from 'classnames';
import { AgencyFormChipProps } from '../../interfaces/types';
import RequiredIcon from '@navi/web-ui/lib/icons/RequiredIcon';

const AgencyFormChip: React.FC<AgencyFormChipProps> = props => {
  const {
    control,
    name,
    rules,
    errors,
    styles,
    inputLabel,
    validationMessage,
    inputOptions,
    isRequired = true,
    isMultipleSelectionAllowed = false
  } = props;

  const [showValidationError, setShowValidationError] = useState(false);

  const handleOnBlur = (value: string | boolean | string[]) => {
    setShowValidationError(!value || (Array.isArray(value) && value.length === 0));
  };

  return (
    <>
      <div className={cx(styles.textContainer, 'pb-1')}>
        <div className="flex flex-row gap-1">
          <Typography variant="p4" className="text-grayscale-2">
            {inputLabel}
          </Typography>
          {isRequired ? <RequiredIcon /> : null}
        </div>
      </div>
      <Controller
        control={control}
        name={name}
        rules={rules}
        render={({ field: { onChange, value } }) => (
          <>
            <div className={styles.questions} onBlur={() => handleOnBlur(value)}>
              {inputOptions?.map(option => (
                <Chip
                  key={option.value}
                  label={option.label}
                  wrapperClasses={cx([
                    styles.chip,
                    {
                      [styles.chipActiveColor]: Array.isArray(value)
                        ? value.includes(option.value)
                        : option.value === value
                    }
                  ])}
                  labelClasses={styles.text}
                  onChipClick={() => {
                    let newValue;
                    if (isMultipleSelectionAllowed) {
                      newValue = Array.isArray(value)
                        ? value.includes(option.value)
                          ? value.filter(val => val !== option.value)
                          : [...value, option.value]
                        : [option.value];
                    } else {
                      newValue = value === option.value ? null : option.value;
                    }
                    onChange(newValue);
                    setShowValidationError(false);
                  }}
                />
              ))}
            </div>

            {errors && showValidationError && (
              <div className={styles.errorContainer}>
                <ErrorIconOutline />
                <Typography variant="p4" className={styles.errorText}>
                  {validationMessage}
                </Typography>
              </div>
            )}
          </>
        )}
      />
    </>
  );
};

export default AgencyFormChip;
